<template>
  <div class="d-booking-detail-mobile">
    <v-progress-linear color="warning" indeterminate rounded height="3" v-if="isLoading"></v-progress-linear>
    <div v-if="!isLoading">
      <div class="d-header-sticky">
        <v-toolbar dense class="toolbar-detail-booking">
          <v-btn icon light @click="back()">
            <v-icon color="grey darken-2">
              arrow_back_ios
            </v-icon>
          </v-btn>

          <v-toolbar-title class="grey--text text--darken-4 fs-15 pl-1">
            <strong>{{ data.ota.otaI18n.find(e => e.lang === defaultI18n).name }} - {{ data.bookingCustomer.name }}</strong>
          </v-toolbar-title>
        </v-toolbar>
        <div class="d-tab-btn">
          <div class="d-chip">
            <v-chip-group mandatory active-class="primary--text">
              <v-chip @click="tab = 'info'">
                {{ $t('BOOKING_INFO') }}
              </v-chip>
              <v-chip @click="tab = 'detail'">
                {{ $t('_BOOKING_DETAIL.TITLE') }}
              </v-chip>
            </v-chip-group>
          </div>
        </div>
      </div>
      <div class="d-tab-info-booking" v-if="tab === 'info'">
        <div class="d-box">
          <div class="d-title-box">{{ $t('_BOOKING_DETAIL.CONTACT.TITLE') }}</div>
          <div class="d-content-box">
            <p>{{ $t('BOOKER') }}</p>
            <p>{{ data.bookingCustomer.name }}</p>
          </div>
          <div class="d-content-box">
            <p>{{ $t('_BOOKING_DETAIL.CONTACT.PHONE') }}</p>
            <p>{{ data.bookingCustomer.phone }}</p>
          </div>
          <div class="d-content-box">
            <p>{{ $t('_BOOKING_DETAIL.CONTACT.EMAIL') }}</p>
            <p>{{ data.bookingCustomer.email }}</p>
          </div>
          <div class="d-content-box">
            <p>{{ $t('COUNTRY') }}</p>
            <p>{{ data.bookingCustomer.country }}</p>
          </div>
        </div>
        <div class="d-box">
          <div class="d-title-box">{{ $t('_BOOKING_DETAIL.BOOKING_DETAIL.TITLE') }}</div>
          <div class="d-content-box">
            <p>{{ $t('_BOOKING_DETAIL.BOOKING_DETAIL.CODE') }}</p>
            <p>{{ data.bookingCode }}</p>
          </div>
          <div class="d-content-box">
            <p>{{ $t('_BOOKING_DETAIL.BOOKING_DETAIL.OTACODE') }}</p>
            <p>{{ data.otaBookingCode }}</p>
          </div>
          <div class="d-content-box">
            <p>{{ $t('_BOOKING_TRANSACTION.TIME_STAY') }}</p>
            <p>
              <template v-if="sysLang == 'vi'">
                {{
                  _formatDateTime(
                    data.arrival,
                    "YYYY-MM-DD",
                    "DD/MM/YYYY"
                  ) +
                  " - " +
                  _formatDateTime(
                    data.departure,
                    "YYYY-MM-DD",
                    "DD/MM/YYYY"
                  )
                }}
              </template>
              <template v-else>
                {{
                  _formatDateTime(
                    data.arrival,
                    "YYYY-MM-DD",
                    "YYYY/MM/DD"
                  ) +
                  " - " +
                  _formatDateTime(
                    data.departure,
                    "YYYY-MM-DD",
                    "YYYY/MM/DD"
                  )
                }}
              </template>
            </p>
          </div>
          <div class="d-content-box">
            <p>{{ $t('_BOOKING_DETAIL.BOOKING_DETAIL.CREATED') }}</p>
            <p>
              {{ utcConvertToLocalTimeZone(data.createdDate) }}
            </p>
          </div>
          <div class="d-content-box">
            <p>{{ $t('NIGHT_NUMBER') }}</p>
            <p>{{ $tc('NIGHT_CAP', data.nights) }}</p>
          </div>
          <div class="d-content-box">
            <p>{{ $t('_BOOKING_DETAIL.BOOKING_DETAIL.NOTE') }}</p>
            <p>{{ data.comment }}</p>
          </div>
          <div class="d-content-box">
            <p>{{ $t('_BOOKING_DETAIL.BOOKING_DETAIL.STATUS') }}</p>
            <p>
              <span :style="{
                color: listBookingStatus.find(x => x.value == data.bookingStatus).color,
                background: listBookingStatus.find(x => x.value == data.bookingStatus).bg
              }" class="d-status-booking">{{
  listBookingStatus.find(x => x.value == data.bookingStatus)
    .text
}}</span>
            </p>
          </div>
          <div class="d-content-box" v-if="data.bookingStatus === 2 || data.bookingStatus === 3">
            <p>{{ $t('CANCEL_REASON') }}</p>
            <p>{{ data.cancellationReason }}</p>
          </div>
        </div>
        <div class="d-btn-cancel" v-if="isContractCancel">
          <v-btn class="w-100" color="error" @click="deactiveDialog = true">{{ $t('_BOOKING_DETAIL.CANCEL') }}</v-btn>
        </div>
      </div>
      <div class="d-tab-detail-booking" v-if="tab === 'detail'">
        <div class="d-box">
          <div class="d-title-box mb-0">{{ $t('ROOM_INFOMATION') }}</div>
          <div v-for="(rateplanid, index) in bookingGroup" :key="index" class="border-bottom">
            <div v-for="item in data.bookingLines.filter(
              x => x.ratePlan.id == rateplanid && x.bookingLineType == 0
            )" class="d-plan pt-2">
              <div class="d-content-box pb-2">
                <div class="mr-2">
                  <div class="fs-10 pb-1">{{ $t("ROOM") }}: {{ item.description }}</div>
                  <div class="text-9C9EA4" v-if="item.guestName"><v-icon color="grey"
                      class="material-icons-outlined">contact_phone</v-icon>&nbsp; {{ item.guestName }}</div>
                  <div class="text-9C9EA4"><v-icon color="grey" class="material-icons-outlined">group</v-icon>&nbsp; {{
                    item.adults }} {{ $t("_BOOKING_DETAIL.ROOM.ADULTS") }},
                    {{ item.children }}
                    {{ $t("_BOOKING_DETAIL.ROOM.CHILDREN") }}, {{ item.baby }}
                    {{ $t("_BOOKING_DETAIL.ROOM.BABY") }}</div>
                  <div class="text-9C9EA4"><v-icon color="grey" class="material-icons-outlined">local_mall</v-icon>&nbsp;
                    {{ item.title }}</div>
                  <div class="fs-10 text-9C9EA4">
                    <v-icon color="grey" class="material-icons-outlined">nights_stay</v-icon>&nbsp; {{ $tc('NIGHT_CAP', item.bookingRates.length) }}
                  </div>
                </div>
                <div class="ml-auto fs-10">
                  {{
                    formatCurrency(item.amountPax)
                  }}
                </div>
              </div>
              <div class="d-content-box" v-if="item.extraAdults > 0">
                <div class="mr-2">
                  <div class="fs-10 pb-1">{{ item.extraAdults }} x {{ $t("EXTRA_ADULT") }}</div>
                </div>
                <div class="ml-auto fs-10">
                  {{
                    formatCurrency(item.amountExtraAdult)
                  }}
                </div>
              </div>
              <div class="d-content-box" v-if="item.extraChildren > 0">
                <div class="mr-2">
                  <div class="fs-10 pb-1">{{ item.extraChildren }} x {{ $t("EXTRA_CHILD") }}</div>
                </div>
                <div class="ml-auto fs-10">
                  {{
                    formatCurrency(item.amountExtraChildren)
                  }}
                </div>
              </div>
              <div class="d-content-box" v-if="item.extraBaby > 0">
                <div class="mr-2">
                  <div class="fs-10 pb-1">{{ item.extraBaby }} x {{ $t("priceExtraBaby") }}</div>
                </div>
                <div class="ml-auto fs-10">
                  {{
                    formatCurrency(item.amountExtraBaby)
                  }}
                </div>
              </div>
              <template v-if="item.bookingServices.length > 0">
                <div class="d-content-box pb-2" v-for="(sv, indexsv) in item.bookingServices" :key="indexsv">
                  <div>
                    <div class="fs-10">{{ sv.quantity }} x {{ sv.name }}</div>
                    <div class="text-9C9EA4">
                      <div class="d-flex">
                        <div class="mr-2"><v-icon color="grey" class="material-icons-outlined">calendar_today</v-icon>
                        </div>
                        <div>
                          <template v-for="(date, i) in sv.bookingServiceRates">
                            <template v-if="i < sv.bookingServiceRates.length - 1">
                              {{
                                _formatDateTime(
                                  date.appliedDate,
                                  "YYYY-MM-DD",
                                  "DD/MM/YYYY"
                                )
                              }},
                            </template>
                            <template v-else>
                              {{
                                _formatDateTime(
                                  date.appliedDate,
                                  "YYYY-MM-DD",
                                  "DD/MM/YYYY"
                                )
                              }}
                            </template>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="ml-auto fs-10">
                    {{ formatCurrency(sv.amount) }}
                  </div>
                </div>
              </template>
            </div>
            <template v-if="
              data.bookingLines.filter(
                y => y.ratePlan.id == rateplanid && y.bookingLineType == 1
              ).length > 0
            ">
              <div class="fs-10 text-success font-weight-bold mt-2">{{ $t("PROMOTION") }}</div>
              <div class="d-content-box pb-2" v-for="(inc, indexsv) in data.bookingLines.filter(
                y => y.ratePlan.id == rateplanid && y.bookingLineType == 1
              )" :key="indexsv">
                <div class="mr-2">
                  <div class="text-success fs-10"> {{ inc.title }} ({{
                    inc.roomType.roomTypeI18n.find(z => z.lang == defaultI18n)
                      .name
                  }})</div>
                </div>
                <div class="ml-auto fs-10 text-success txt-nowrap">
                  {{
                    formatCurrency(inc.lineTotal)
                  }}
                </div>
              </div>
            </template>
          </div>
          <div class="d-content-box font-weight-bold pt-2 fs-12">
            <div>{{ $t("_BOOKING_DETAIL.SUB_TOTAL") }}</div>
            <div class="ml-auto">{{ formatCurrency(subTotal) }}</div>
          </div>
          <div class="d-content-box font-weight-bold pt-1 text-success fs-12">
            <div>{{ $t("_BOOKING_DETAIL.PROMOTION.TITLE") }}</div>
            <div class="ml-auto">{{ formatCurrency(totalPromotion) }}</div>
          </div>
          <div class="d-content-box font-weight-bold pt-1 fs-12">
            <div>{{ $t("_BOOKING_DETAIL.TOTAL") }}</div>
            <div class="ml-auto">{{ formatCurrency(data.amount) }}</div>
          </div>
          <div class="d-content-box font-weight-bold pt-1 fs-12">
            <div>{{ $t("_BOOKING_DETAIL.COMMISSION") }}</div>
            <div class="ml-auto">{{ formatCurrency(data.commission) }}</div>
          </div>
          <div class="d-content-box font-weight-bold pt-1 fs-12">
            <div>{{ $t("_BOOKING_DETAIL.BEFORE_COMMISSION") }}</div>
            <div class="ml-auto">{{ data.priceBeforeCommission ?  formatCurrency(data.priceBeforeCommission) : 'N/A' }}</div>
          </div>
          <div class="d-content-box font-weight-bold pt-1 fs-12">
            <div>{{ $t("_BOOKING_DETAIL.AFTER_COMMISSION") }}</div>
            <div class="ml-auto">{{ data.priceAfterCommission ? formatCurrency(data.priceAfterCommission) : 'N/A' }}</div>
          </div>
          <div class="d-content-box pt-1">
            <div class="text-danger fs-11">{{ $t("COMMISSION_RATE_NOTE") }}</div>
          </div>
        </div>
        <div class="d-box">
          <div class="d-title-box mb-0">{{ $t('PAYMENT_HISTORY') }}</div>
          <div v-for="item in data.bookingPayments" :key="item.transactionDate" class="border-bottom pb-2">
            <div class="d-content-box pt-2">
              <p> {{ $t('PAYMENT_CODE') }}</p>
              <p>{{ item.transactionRef }}</p>
            </div>
            <div class="d-content-box">
              <p> {{ $t("_BOOKING_TRANSACTION_DETAIL.PAYMENT_METHOD") }}</p>
              <p>{{ item.paymentMethod }}</p>
            </div>
            <div class="d-content-box">
              <p> {{ $t("_BOOKING_TRANSACTION_DETAIL.TRANSACTION_CODE") }}</p>
              <p>{{ item.transactionNo }}</p>
            </div>
            <div class="d-content-box">
              <p> {{ $t("EZPAYREF") }}</p>
              <p>{{ item.ezpayRef }}</p>
            </div>
            <div class="d-content-box">
              <p> {{ $t("PAYMENT_TYPE") }}</p>
              <p>{{ paymentTypeOption.find(x => x.code === item.paymentType).text }}</p>
            </div>
            <div class="d-content-box">
              <p> {{ $t("_BOOKING_TRANSACTION_DETAIL.AMOUNT") }}</p>
              <p>{{ formatCurrency(item.amount) }}</p>
            </div>
            <div class="d-content-box">
              <p> {{ $t("_BOOKING_TRANSACTION_DETAIL.TRANSACTION_DATE") }}</p>
              <p>{{ formatDateTime(item.transactionDate) }}</p>
            </div>
            <div class="d-content-box">
              <p> {{ $t("PAYMENT_STATUS") }}</p>
              <p>{{ paymentStatusOption.find(x => x.code === item.paymentStatus).text }}</p>
            </div>
            <div class="d-content-box">
              <p> {{ $t("_BOOKING_TRANSACTION_DETAIL.NOTE") }}</p>
              <p>{{ item.note }}</p>
            </div>
          </div>
          <div class="d-content-box pt-2">
            <p> {{ $t("HOTEL_LOG_payableAmount") }}</p>
            <p class="text-right">{{ formatCurrency(totalBookingPayment) }}</p>
          </div>
          <div class="d-content-box">
            <p> {{ $t("_BOOKING_DETAIL.UNPAID") }}</p>
            <p class="text-right">{{ formatCurrency(
              data.amount - totalBookingPayment
            ) }}</p>
          </div>
        </div>
      </div>
      <v-dialog v-model="deactiveDialog" max-width="400" content-class="dialog-confirm dialog-cancel">
        <div>
          <div class="title-cancel">{{ $t('_BOOKING_DETAIL.CONFIRM_CANCEL') }}</div>
          <div class="content-cancel">
            <textarea class="form-control mt-4 no-resize" v-on:keyup="countdown" v-model="dataCancel.reason" :rows="3"
              :error.sync="error.reason.error" :placeholder="$t('_BOOKING_DETAIL.CONFIRM_REASON')" />
            <div class="warn-text-container">
              <div class="warn-text">
                <div v-if="remainingCount <= 0">
                  <span class='text-right text-small'>{{ $t('OVER_CHARACTER') }}</span>
                </div>
              </div>
              <span class='text-right text-small text-count'>{{ currentCount }} / {{ maxCount }}</span>
            </div>
            <v-row class="btn-cancel">
              <v-col cols="6">
                <button class="w-100" @click="deactiveDialog = false">{{ $t('BACK') }}</button>
              </v-col>
              <v-col cols="6">
                <v-btn :disabled="remainingCount <= 0 || !dataCancel.reason" class="w-100" depressed color="error"
                  @click="validateCancelBooking">{{ $t('_TRAVEL_AGENT.CONFIRM') }}</v-btn>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-dialog>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.line-break {
  border-top: 1px dashed #ece7e7;
  padding: 5px 0;
}

.booking-line {
  .item {
    border-bottom: 1px solid #ecebeb;
    padding-bottom: 5px;
    margin-bottom: 5px;

    &:last-child {
      border: none;
      padding-bottom: 0;
      margin-bottom: 0;
    }
  }
}

.col-12 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
}

.warn-text-container {
  margin-top: 10px;
}

.warn-text {
  display: inline-block;
  color: #d9390d;
  width: 80%;
}

.text-count {
  position: relative;
  top: 2px;
  float: right;
  display: inline-block;
}

.item-rateplan>div {
  border-bottom: 1px dashed #fbc27a8c;
  margin-bottom: 10px;

  &:last-child {
    border: none;
  }
}

.item-promotion {
  border-top: 1px dashed #28a74536;
  padding-top: 10px !important;
}
</style>

<script>
import { getBkDtError } from "@/_helpers/config.js";
import {
  _validateFormI18n,
  _alert,
  _formatDateTimeUTCToLocal,
  _formatCurrency
} from "@/_helpers/function.js";
import { chainService } from "@/_services/ChainManage/chain.service.js";
import { service } from "@/_services/Booking/booking.service.js";
import printJS from "print-js";
import moment from "moment";

export default {
  components: {},
  data() {
    return {
      subTotal: 0,
      totalPromotion: 0,
      bookingGroup: [],
      totalBookingPayment: 0,
      sysLang: this.$i18n.locale,
      maxCount: 255,
      remainingCount: 255,
      currentCount: 0,
      disable: false,
      hasError: false,
      isLoading: false,
      data: {},
      headers: [
        {
          text: this.$t("STT"),
          class: "text-center"
        },
        {
          text: this.$t("SALE_PACKAGE"),
          value: "name"
        },
        {
          text: this.$t("_BOOKING_DETAIL.ROOM.APPLY_DATE"),
          value: "price",
          class: "text-center"
        },
        {
          text: this.$t("_BOOKING_DETAIL.ROOM.ADULTS"),
          value: "quantity",
          class: "text-center"
        },
        {
          text: this.$t("_BOOKING_DETAIL.ROOM.CHILDREN"),
          value: "total",
          class: "text-center"
        },
        {
          text: this.$t("_BOOKING_DETAIL.ROOM.BABY"),
          value: "total",
          class: "text-center"
        },
        {
          text: this.$t("TOTAL"),
          value: "total",
          class: "text-right"
        }
      ],
      listBookingStatus: [
        {
          value: null,
          text: this.$t("ALL"),
        },
        {
          value: 0,
          text: this.$t("_BOOKING.STATUS.AWAIT_PAYMENT"),
          color: "rgb(254, 209, 47)",
          bg: "rgba(253, 185, 19, 0.12)"
        },
        {
          value: 1,
          text: this.$t("_BOOKING.STATUS.CONFIRM"),
          color: "#0da313",
          bg: "rgba(41, 184, 105, 0.12)"
        },
        {
          value: 2,
          text: this.$t("_BOOKING.STATUS.CANCEL"),
          color: "#808080",
          bg: "rgba(128, 128, 128, 0.12)"
        },
        {
          value: 3,
          text: this.$t("_BOOKING.STATUS.VOID"),
          color: "#262626",
          bg: "rgba(38, 38, 38, 0.12)"
        },
        {
          value: 4,
          text: this.$t("_BOOKING.STATUS.IN_SERVICE"),
          color: "#262626",
          bg: "rgba(38, 38, 38, 0.12)"
        },
        {
          value: 5,
          text: this.$t("_BOOKING.STATUS.CLOSE"),
          color: "#262626",
          bg: "rgba(38, 38, 38, 0.12)"
        },
        {
          value: 6,
          text: this.$t("_BOOKING.STATUS.PAYMENT_FAILED"),
          color: "#ff0000",
          bg: "rgba(255, 0, 0, 0.12)"
        },
        {
          value: 7,
          text: this.$t("_BOOKING.STATUS.AWAIT_FULLY_PAYMENT"),
          color: "#fed12f",
          bg: "rgba(254, 209, 47, 0.12)"
        },
      ],
      contractMayCancelStatus: [0, 1, 6, 7],
      dataCancel: {
        reason: ""
      },
      error: getBkDtError(),
      isContractCancel: false,
      deactiveDialog: false,
      tab: 'info',
      paymentTypeOption: [
        {
          code: 0,
          text: this.$t('PAYMENT')
        },
        {
          code: 1,
          text: this.$t('REFUND')
        },

        {
          code: 2,
          text: this.$t('CANCELLATION_REFUND')
        },
        {
          code: 3,
          text: this.$t('CANCELLATION_FEE')
        }
      ],
      paymentStatusOption: [
        {
          code: 0,
          text: this.$t('WAITING_PAYMENT')
        },
        {
          code: 1,
          text: this.$t('SUCCESS_PAYMENT')
        },

        {
          code: 2,
          text: this.$t('FAILED')
        }
      ],
      numberNights: []
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    _formatDateTimeUTCToLocal(value, inputFormat, outputFormat) {
      if (!value) {
        return "";
      }
      return _formatDateTimeUTCToLocal(value, inputFormat, outputFormat);
    },
    _formatDateTime(value, inputFormat, outputFormat) {
      if (!value) {
        return "";
      }
      return moment(value).format(outputFormat);
    },
    formatCurrency(amount) {
      return _formatCurrency(amount, this.data.currencyCode);
    },
    sortBookingLineType(a, b) {
      return parseFloat(a.bookingLineType) - parseFloat(b.bookingLineType);
    },
    // Run when start
    initialize() {
      let requests = [];
      if (!this.$route.params || !this.$route.params.code) {
        this.back();
      }
      this.data.code = this.$route.params.code;
      requests.push(this.getBookingDetail(this.data.code));
      this.isLoading = true;
      Promise.all(requests).finally(() => (this.isLoading = false));
    },
    // Go back
    back() {
      this.$router.back();
    },
    // Get booking status text
    getBookingStatusText(key) {
      const result = this.listBookingStatus.find(item => item.value === key);
      return result ? result.key : "";
    },
    showPromotion(description) {
      let data = description.split("|");
      let start = "";
      let end = "";
      if (this.sysLang == "vi") {
        start = _formatDateTimeUTCToLocal(data[1], "YYYY-MM-DD", "DD/MM/YYYY");
        end = _formatDateTimeUTCToLocal(data[2], "YYYY-MM-DD", "DD/MM/YYYY");
      } else {
        start = _formatDateTimeUTCToLocal(
          data[1],
          "YYYY-MM-DD hh:mm A",
          "YYYY/MM/DD HH:mm"
        );

        end = _formatDateTimeUTCToLocal(data[2], "YYYY-MM-DD", "DD/MM/YYYY");
      }

      return (
        '<span class="font-weight-bold">' +
        this.$t("PROMOTION") +
        ": " +
        data[0] +
        "</span><br><span>" +
        this.$t("_BOOKING_DETAIL.ROOM.APPLY_DATE") +
        ": " +
        start +
        " - " +
        end +
        "</span>"
      );
    },
    showService(description) {
      let data = description.split("|");
      let start = "";
      let end = "";
      if (this.sysLang == "vi") {
        start = _formatDateTimeUTCToLocal(data[1], "YYYY-MM-DD", "DD/MM/YYYY");
        end = _formatDateTimeUTCToLocal(data[2], "YYYY-MM-DD", "DD/MM/YYYY");
      } else {
        start = _formatDateTimeUTCToLocal(
          data[1],
          "YYYY-MM-DD hh:mm A",
          "YYYY/MM/DD HH:mm"
        );

        end = _formatDateTimeUTCToLocal(data[2], "YYYY-MM-DD", "DD/MM/YYYY");
      }

      return (
        '<span class="font-weight-bold">' +
        this.$t("SERVICES") +
        ": " +
        data[0] +
        "</span><br><span>" +
        this.$t("_BOOKING_DETAIL.ROOM.APPLY_DATE") +
        ": " +
        start +
        " - " +
        end +
        "</span>"
      );
    },
    // load booking detail
    async getBookingDetail(code) {
      return await service.getBookingDetail(code).then(res => {
        if (res.responseCode === 0) {
          this.data = res.data;

          this.data.bookingPayments.forEach(x => {
            this.totalBookingPayment = this.totalBookingPayment + x.amount;
          });

          // Nhóm bookingline
          const booking_line_rateplan_id = [];
          const nights = [];
          this.data.bookingLines.forEach((element, index) => {
            if (element.bookingLineType === 0) {
              booking_line_rateplan_id.push(element.ratePlan.id);
              element.bookingRates.forEach(n => {
                nights.push(n.appliedDate)
              })
            }
          });
          this.numberNights = [
            ...Array.from(new Set(nights))
          ];

          // Xoá các rateplandid trùng lặp
          this.bookingGroup = [
            ...Array.from(new Set(booking_line_rateplan_id))
          ];

          // totalPromotion
          this.data.bookingLines.forEach((element, index) => {
            if (element.bookingLineType === 1) {
              // console.log(element.lineTotal);
              this.totalPromotion = +this.totalPromotion + +element.lineTotal;
            }
          });

          // subTotal
          this.subTotal = +this.data.amount + Math.abs(this.totalPromotion);

          // Check booking status
          if (this.contractMayCancelStatus.indexOf(this.data.bookingStatus) > -1 && this.data.otaCode === 'EZ_BE') {
            this.isContractCancel = true;
          } else {
            this.isContractCancel = false;
          }
        } else {
          _alert(res, this.$t(res.data), false);
        }
      });
    },
    // print booking
    printBooking() {
      // printJS({ printable: 'printSection', type: 'html', targetStyles: ['*'] });
      // Get HTML to print from element
      const prtHtml = document.getElementById("printSection").innerHTML;
      // Get all stylesheets HTML
      let stylesHtml = `<style type="text/css">.not-print {display: none}</style>`;
      // Open the print window
      const WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=0,height=0,toolbar=0,scrollbars=0,status=0"
      );
      WinPrint.document.write(`<!DOCTYPE html>
      <html>
        <head>
          ${stylesHtml}
          ${getCssText()}
        </head>
        <body style="padding: 20px; background: #f6f6f6; visible: hidden;">
          ${prtHtml}
        </body>
      </html>`);
      WinPrint.document.close();
      this.$nextTick().then(() => {
        WinPrint.focus();
        WinPrint.print();
        WinPrint.close();
      });
    },
    countdown() {
      this.remainingCount = this.maxCount - this.dataCancel.reason.length;
      this.currentCount = this.dataCancel.reason.length;
    },
    // Validate booking, then cancel
    validateCancelBooking() {
      let { isValid, error } = _validateFormI18n(this.dataCancel, this.error);
      this.error = error;
      if (!isValid) return false;
      this.cancelBooking(this.data.bookingCode, this.dataCancel.reason);
    },
    // Cancel booking
    cancelBooking(code, reason) {
      let temp = {
        code: code,
        reason: reason
      };
      this.isLoading = true;
      service
        .cancelBooking(temp)
        .then(res => {
          if (res.responseCode === 0) {
            // this.initialize();
            _alert(res, this.$t(res.data));
          } else {
            this.deactiveDialog = false;
            _alert(res, this.$t(res.data), false);
          }
        })
        .finally(() => (this.isLoading = false));
    },
    getStatusColor(status) {
      const selected = this.listBookingStatus.find(item => item.key === status);
      return selected ? selected.color : status;
    },
    _moment: moment
  }
};
</script>
<style lang="scss" scoped>
.room-card {
  .row {
    .col {
      &:nth-of-type(1) {
        width: 16%;
        max-width: 16%;
      }

      &:nth-of-type(2) {
        width: 16%;
        max-width: 16%;
      }

      &:nth-of-type(3) {
        width: 16%;
        max-width: 16%;
      }

      &:nth-of-type(4) {
        width: 16%;
        max-width: 16%;
      }

      &:nth-of-type(5) {
        width: 10%;
        max-width: 10%;
      }

      &:nth-of-type(6) {
        width: 10%;
        max-width: 10%;
      }

      &:nth-of-type(7) {
        width: 16%;
        max-width: 16%;
      }
    }
  }
}

.payment-history-card {
  .row {
    .col {
      &:nth-of-type(1) {
        width: 22%;
        max-width: 22%;
      }

      &:nth-of-type(2) {
        width: 16%;
        max-width: 16%;
      }

      &:nth-of-type(3) {
        width: 26%;
        max-width: 26%;
      }

      &:nth-of-type(4) {
        width: 12%;
        max-width: 12%;
      }

      &:nth-of-type(5) {
        width: 25%;
        max-width: 25%;
      }
    }
  }
}

.border-right {
  border-right: solid thin rgba(0, 0, 0, 0.12) !important;
}
</style>
